import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { CityService } from "../../core/service/city.service";
import { BankService } from "../../core/service/bank.service";
import { Bank } from "../../core/model/bank";
import { City } from "../../core/model/city";

@Component({
  selector: "app-edit-bank",
  templateUrl: "./edit-bank.component.html",
  styleUrls: ["./edit-bank.component.scss"],
})
export class EditBankComponent implements OnInit {
  pressButton: Boolean = false;
  form: FormGroup;
  loading = true;

  bankId: number;
  bank: Bank;
  cities: City[];

  constructor(
    private _router: Router,
    private _cityService: CityService,
    private _bankService: BankService,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
      description: [null, Validators.compose([Validators.nullValidator])],
      address: [null, Validators.compose([Validators.required])],
      ville: [null, Validators.compose([Validators.nullValidator])],
      city: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe((params: Params) => {
      this.bankId = params["bankId"];
      this.getBank(this.bankId);
      this.getCities();
    });
  }

  getBank(bankId) {
    this.loading = true;
    this._bankService.getBankById(bankId).subscribe(
      (data) => {
        this.bank = {
          ...data,
          active: data.active === true || data.active === ("true" as any),
          city: data.city ? { ...data.city } : new City(),
        };
        if (!this.bank.city.id) {
          this.bank.city = this.bank.city || new City();
        }
        this.loading = false;
      },
      (error) => {
        console.log(error);
        this.loading = false;
      }
    );
  }

  getCities() {
    this._cityService.getAllCities().subscribe(
      (data) => {
        this.cities = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.pressButton = true;

    const selected = (this.cities || []).find(
      (c) => c.id == this.bank.city.id
    );
    if (selected) {
      this.bank.city = { ...selected };
    }

    this._bankService
      .putBank(this.bank)
      .pipe(first())
      .subscribe(
        () => {
          this.pressButton = false;
          this.goToList();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }

  cancel(): void {
    this.goToList();
  }

  private goToList(): void {
    this._router.navigateByUrl("/parametrage/bank");
  }
}
